
import Vue from "vue";
import AppColorPicker from "@/components/ColorPicker.vue";
import { ViewTotal } from "@/utils/views/view-total";
import AppTotalEditContentWrapper from "./TotalEditContentWrapper.vue";

export default Vue.extend({
	props: {
		currentTab: {
			type: Number,
			required: true
		},
		value: {
			type: Object as ()=>ViewTotal,
			required: true
		},
	},
	computed: {
		previewText():string{
			return this.value.Label.getTranslation(this.$i18n.locale).replaceAll("{value}", "123.45");
		}
	},
	components: {
		AppColorPicker,
		AppTotalEditContentWrapper
	},
	i18nEx: {
		componentPrefix: "components.view-editor"
	}
});
